<button
    type="button"
    class="btn btn-default nlr-icon-btn"
    id="enlargementToolBtn"
    [ngClass]="{active : isWidgetActive()}"
    [title]="getTooltip()"
    [disabled]="isWidgetDisabled()"
    (click)="onClick()"
    right-click="enlargement">
    <i class="nlrp-icon nlrp-icon-enlargement"></i>
</button>
@if (isWidgetActive()) {
    <div
        id="enlargement"
        class="widget container-fluid well"
        cdkDrag
        [cdkDragConstrainPosition]="computeDragPosition"
        #widget>
        <form
            id="enlargementForm"
            #enlargementForm="ngForm"
            novalidate
            autocomplete="off">
            <div
                class="col-xs-12 widget-header"
                cdkDragHandle>
                <span>{{widgetConfig.header}}</span>
                <div class="pull-right btn-group btn-group-xs">
                    <nlrp-help-link
                        [url]="getHelpUrl()"
                        [pageTitle]="getHelpPageTitle()"></nlrp-help-link>
                    <i
                        class="nlrp-icon nlrp-18"
                        [ngClass]="open ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"
                        title="{{open ? widgetConfig.collapseTooltip : widgetConfig.expandTooltip}}"
                        (click)="showOrHideWidgetContent()">
                    </i>
                    <i
                        class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                        id="closeEnlargementBtn"
                        title="{{widgetConfig.closeTooltip}}"
                        (click)="closeWidget();"></i>
                </div>
            </div>
            @if (open) {
                <div class="widget-content">
                    <div class="mgt10">
                        <div class="col-xs-12 enlargement-body">
                            <div class="row">
                                @if (errors.length > 0) {
                                    <div class="enlargement-tool-errors">
                                        <div class="panel panel-default">
                                            <div
                                                class="panel-heading"
                                                (click)="showErrors = !showErrors">
                                                <span>Errors</span>
                                                <span class="badge">{{errors.length}}</span>
                                                <i
                                                    class="nlrp-icon"
                                                    [ngClass]="showErrors ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"></i>
                                            </div>
                                            @if (showErrors) {
                                                <div class="panel-body">
                                                    @for (error of errors; track error) {
                                                        <div>{{error}}</div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                                @if (errors.length>0) {
                                    <li
                                        role="presentation"
                                        class="mgb10"></li>
                                }
                                <div class="col-xs-12 ">
                                    @for (attribute of attributes; track attribute) {
                                        <div [ngClass]="{'has-error': hasError(type + attribute.prop)}">
                                            @if (attribute.attributeType && attribute.attributeType === 'DOMAIN') {
                                                <div class="col-xs-12 p0 mgb10">
                                                    <label
                                                        class="control-label"
                                                        [ngClass]="{'required-input':attribute.mandatoryAtLodgement}"
                                                        for="{{type + attribute.prop}}"
                                                        >{{attribute.name}}:</label
                                                    >
                                                    <ng-select
                                                        class="nlr-ng-select"
                                                        [searchable]="false"
                                                        [clearable]="false"
                                                        [id]="type + attribute.prop"
                                                        [name]="type + attribute.prop"
                                                        [disabled]="isEditMode() && !editPrintArea"
                                                        placeholder="Select"
                                                        [items]="attribute.values"
                                                        [ngModel]="attribute.value"
                                                        (change)="scaleChanged(attribute, $event)">
                                                        <ng-template
                                                            ng-label-tmp
                                                            let-value="item">
                                                            {{value.description || value.referenceScale || 'Select'}}
                                                        </ng-template>
                                                        <ng-template
                                                            ng-option-tmp
                                                            let-option="item">
                                                            {{option.description ? option.description : option.referenceScale}}
                                                        </ng-template>
                                                    </ng-select>
                                                    @if (!hasRequiredError(type + attribute.prop)&&hasError(type + attribute.prop)) {
                                                        <div class="help-block">
                                                            <span>Error!</span>
                                                            <span>{{attribute.name}} value is invalid.</span>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            @if (attribute.attributeType && attribute.attributeType === 'BOOLEAN') {
                                                <div
                                                    class="col-xs-12 p0 mgb10"
                                                    [ngClass]="{'has-error': enlargementForm[type + attribute.prop].$invalid && enlargementForm[type + attribute.prop].$dirty}">
                                                    <label
                                                        class="control-label"
                                                        [ngClass]="{'required-input':attribute.mandatoryAtLodgement}"
                                                        for="{{type + attribute.prop}}"
                                                        >{{attribute.name}}:</label
                                                    >
                                                    <div
                                                        class="checkbox mg0"
                                                        title="{{attribute.name}}">
                                                        <div class="checkbox-inline">
                                                            <i
                                                                class="nlrp-icon"
                                                                [ngClass]="{'active': attribute.value,
                                               'nlrp-icon-check-box-selected' : attribute.value,
                                               'nlrp-icon-check-box-unselected': !attribute.value}"
                                                                (click)="attribute.value = !attribute.value"></i>
                                                            <input
                                                                type="checkbox"
                                                                id="{{type + attribute.prop}}"
                                                                [name]="type + attribute.prop"
                                                                [(ngModel)]="attribute.value"
                                                                [required]="attribute.mandatoryAtLodgement"
                                                                style="visibility: hidden;" />
                                                        </div>
                                                    </div>
                                                    @if (!hasRequiredError(type + attribute.prop) && hasError(type + attribute.prop)) {
                                                        <div class="help-block">
                                                            <span>Error!</span>
                                                            <span>{{attribute.name}} value is invalid.</span>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            @if (attribute.attributeType && attribute.attributeType === 'RADIO') {
                                                <div
                                                    class="col-xs-12 p0 mgb10"
                                                    [ngClass]="{'has-error': hasError(type + attribute.prop)}">
                                                    <label
                                                        class="control-label"
                                                        [ngClass]="{'required-input':attribute.mandatoryAtLodgement}"
                                                        for="{{type + attribute.prop}}"
                                                        >{{attribute.name}}:</label
                                                    >
                                                    @for (option of attribute.values; track trackByIndex(i, option); let i = $index) {
                                                        <label
                                                            class="nlr-radio"
                                                            title="Select {{attribute.name}}">
                                                            <input
                                                                type="radio"
                                                                [name]="type + attribute.prop"
                                                                [value]="option.value"
                                                                [(ngModel)]="attribute.value"
                                                                [required]="attribute.mandatoryAtLodgement" />
                                                            <span>{{option.description}}</span>
                                                        </label>
                                                    }
                                                    @if (!hasRequiredError(type + attribute.prop) && hasError(type + attribute.prop)) {
                                                        <div class="help-block">
                                                            <span>Error!</span>
                                                            <span>{{attribute.name}} value is invalid.</span>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            @if (attribute.attributeType && attribute.attributeType.indexOf('STRING') !== -1) {
                                                <div
                                                    class="col-xs-12 p0 mgb10"
                                                    [ngClass]="{'has-error':hasError(type + attribute.prop)}">
                                                    <label
                                                        class="control-label"
                                                        [ngClass]="{'required-input':attribute.mandatoryAtLodgement}"
                                                        for="{{type + attribute.prop}}"
                                                        >{{attribute.name}}:</label
                                                    >
                                                    <div class="input-group">
                                                        <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            id="{{type + attribute.prop}}"
                                                            [name]="type + attribute.prop"
                                                            [(ngModel)]="attribute.value"
                                                            (change)="validate()"
                                                            [required]="attribute.mandatoryAtLodgement"
                                                            [maxLengthInputLimit]="attribute.attributeTypeLength"
                                                            placeholder="Enter {{attribute.name}}"
                                                            title="Enter {{attribute.name}}"
                                                            autocomplete="off" />
                                                    </div>
                                                    @if (checkNameAttributeValue(attribute) && checkEnlargementname()) {
                                                        <div class="help-block">
                                                            <span>Error!</span>
                                                            <span
                                                                >Error inserting features. {{attribute.name}} must be no longer than
                                                                {{attribute.attributeTypeLength}} characters.</span
                                                            >
                                                        </div>
                                                    }
                                                    @if (!hasRequiredError(type + attribute.prop) && hasError(type + attribute.prop)) {
                                                        <div class="help-block">
                                                            <span>Error!</span>
                                                            <span>{{attribute.name}} value is invalid.</span>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            @if (attribute.attributeType && attribute.attributeType.indexOf('INTEGER') !== -1) {
                                                <div
                                                    class="col-xs-12 p0 mgb10"
                                                    [ngClass]="{'has-error': hasError(type + attribute.prop)}">
                                                    <label
                                                        class="control-label"
                                                        [ngClass]="{'required-input':attribute.mandatoryAtLodgement}"
                                                        for="{{type + attribute.prop}}"
                                                        >{{attribute.name}}:</label
                                                    >
                                                    <div class="input-group">
                                                        <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                                        <input
                                                            type="number"
                                                            class="form-control"
                                                            id="{{type + attribute.prop}}"
                                                            name="type + attribute.prop"
                                                            [(ngModel)]="attribute.value"
                                                            [required]="attribute.mandatoryAtLodgement"
                                                            [maxLengthInputLimit]="attribute.attributeTypeLength"
                                                            placeholder="Enter {{attribute.name}}"
                                                            title="Enter {{attribute.name}}" />
                                                    </div>
                                                    @if (!hasRequiredError(type + attribute.prop) && hasError(type + attribute.prop)) {
                                                        <div class="help-block">
                                                            <span>Error!</span>
                                                            <span>{{attribute.name}} value is invalid.</span>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            @if (attribute.attributeType && attribute.attributeType.indexOf('DECIMAL') !== -1) {
                                                <div
                                                    class="col-xs-12 p0 mgb10"
                                                    [ngClass]="{'has-error': hasError(type + attribute.prop)}">
                                                    <label
                                                        class="control-label"
                                                        [ngClass]="{'required-input':attribute.mandatoryAtLodgement}"
                                                        for="{{type + attribute.prop}}"
                                                        >{{attribute.name}}:</label
                                                    >
                                                    <div class="input-group">
                                                        <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                                        <input
                                                            type="number"
                                                            class="form-control"
                                                            id="{{type + attribute.prop}}"
                                                            [name]="type + attribute.prop"
                                                            [(ngModel)]="attribute.value"
                                                            [required]="attribute.mandatoryAtLodgement"
                                                            placeholder="Enter {{attribute.name}}"
                                                            title="Enter {{attribute.name}}"
                                                            [nlrPattern]="attribute.pattern"
                                                            step="0.01" />
                                                    </div>
                                                    @if (!hasRequiredError(type + attribute.prop) && hasError(type + attribute.prop)) {
                                                        <div class="help-block">
                                                            <span>Error!</span>
                                                            <span>{{attribute.name}} value is invalid.</span>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                    @if (isEditMode()) {
                                        <div>
                                            <div class="col-xs-12 p0 mgb10">
                                                <label class="control-label">Print area:</label>
                                                <div class="inner">
                                                    @if (canEditPrintArea()) {
                                                        <button
                                                            type="button"
                                                            class="btn btn-default nlr-icon-btn"
                                                            id="editPrintAreaBtn"
                                                            title="Edit print area"
                                                            [disabled]="editPrintAreaDisabled()"
                                                            (click)="clickTool('edit-print-area')">
                                                            <i
                                                                class="nlrp-icon nlrp-icon-edit"
                                                                id="editPrintArea"></i>
                                                        </button>
                                                    }
                                                    @if (editPrintArea) {
                                                        <button
                                                            type="button"
                                                            class="btn btn-default nlr-icon-btn"
                                                            id="applyPrintAreaChangesBtn"
                                                            title="Apply print area changes"
                                                            [disabled]="applyPrintAreaChangesDisabled()"
                                                            (click)="clickTool('update-print-area')">
                                                            <i class="nlrp-icon nlrp-icon-accept"></i>
                                                        </button>
                                                    }
                                                    @if (editPrintArea) {
                                                        <button
                                                            type="button"
                                                            class="btn btn-default nlr-icon-btn"
                                                            id="cancelPrintAreaChangesBtn"
                                                            title="Cancel print area changes"
                                                            (click)="clickTool('update-print-area-cancel')">
                                                            <i class="nlrp-icon nlrp-icon-close-cancel"></i>
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div [ngClass]="{'has-error': checkEnlargementname()}">
                                        <div
                                            class="col-xs-12 p0 mgb10"
                                            [ngClass]="{'has-error': {'has-error': checkEnlargementname()}}">
                                            @if (isCreateMode()) {
                                                <label
                                                    class="control-label"
                                                    [ngClass]="{'required-input':isCreateMode()}"
                                                    >Print area:</label
                                                >
                                            }
                                            @if (isEditMode()) {
                                                <label class="control-label">Clipping area:</label>
                                            }
                                            <div class="inner">
                                                @if (isCreateMode()) {
                                                    <button
                                                        type="button"
                                                        class="btn nlr-icon-btn"
                                                        [ngClass]="{
                                                        'btn-default': !printAreaCreateButtonHasError(),
                                                        'btn-danger': printAreaCreateButtonHasError()
                                                    }"
                                                        id="printAreaToolEnlargeBtn"
                                                        [disabled]="isPrintAreaDisabled()"
                                                        (click)="clickTool('set-print-area')">
                                                        <i class="nlrp-icon nlrp-icon-print-area"></i>
                                                    </button>
                                                }
                                                @if (canEditClipping()) {
                                                    <button
                                                        type="button"
                                                        class="btn btn-default nlr-icon-btn"
                                                        id="editClippingAreaBtn"
                                                        title="Edit clipping area to hide unwanted features"
                                                        [disabled]="editClippingDisabled()"
                                                        (click)="clickTool('edit-clipping')">
                                                        <i
                                                            class="nlrp-icon nlrp-icon-edit"
                                                            id="editClipping"></i>
                                                    </button>
                                                }
                                                @if (editClipping) {
                                                    <button
                                                        type="button"
                                                        class="btn btn-default nlr-icon-btn"
                                                        id="applyClippingBtn"
                                                        title="Apply clipping area changes"
                                                        (click)="clickTool('apply-clipping')">
                                                        <i class="nlrp-icon nlrp-icon-accept"></i>
                                                    </button>
                                                }
                                                @if (editClipping) {
                                                    <button
                                                        type="button"
                                                        class="btn btn-default nlr-icon-btn"
                                                        id="cancelClippingAreaBtn"
                                                        title="Cancel clipping area changes"
                                                        (click)="clickTool('update-clipping-cancel')">
                                                        <i class="nlrp-icon nlrp-icon-close-cancel"></i>
                                                    </button>
                                                }
                                                @if (canCreateClipping()) {
                                                    <button
                                                        type="button"
                                                        class="btn btn-default nlr-icon-btn"
                                                        id="createClippingAreaBtn"
                                                        title="Create a clipping area"
                                                        [disabled]="createClippingDisabled()"
                                                        (click)="clickTool('create-clipping')">
                                                        <i class="nlrp-icon nlrp-icon-scissors"></i>
                                                    </button>
                                                }
                                                @if (canClearClipping()) {
                                                    <button
                                                        type="button"
                                                        class="btn btn-default nlr-icon-btn"
                                                        id="finishClippingDrawingManuallyBtn"
                                                        title="Finish Clipping Drawing Manually"
                                                        (click)="finishClippingDrawingManually()">
                                                        <i class="nlrp-icon nlrp-icon-accept"></i>
                                                    </button>
                                                }
                                                @if (canClearClipping()) {
                                                    <button
                                                        type="button"
                                                        class="btn btn-default nlr-icon-btn"
                                                        id="clearClippingAreaBtn"
                                                        title="Clear"
                                                        [disabled]="clearClippingDisabled()"
                                                        (click)="clickTool('clear-clipping')">
                                                        <i class="nlrp-icon nlrp-icon-close"></i>
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <div class="col-xs-12 inline-bottom-buttons">
                <button
                    class="btn btn-default nlr-btn-sm create"
                    id="createEnlargementBtn"
                    [disabled]="createOrSaveDisabled()"
                    (click)="createOrSave()">
                    {{isCreateMode() ? 'Create' : 'Apply' }}
                </button>
                <button
                    class="btn btn-default nlr-btn-sm clear"
                    id="clearEnlargementBtn"
                    (click)="clear()">
                    Reset
                </button>
                @if (isEditMode()) {
                    <button
                        class="btn btn-default nlr-btn-sm clear"
                        id="deleteEnlargementBtn"
                        [disabled]="deleteDisabled()"
                        (click)="delete()">
                        Delete
                    </button>
                }
                <button
                    class="btn btn-default nlr-btn-sm cancel"
                    id="cancelEnlargementBtn"
                    (click)="closeWidget();">
                    Close
                </button>
            </div>
        </form>
    </div>
}
